import React from "react";

const Help = () => {
  return (
    <section id="help">
      <div className="container">
        <div className="row row-header">
          <h4>HELP</h4>
        </div>
        <div className="how-section1">
          <div className="row">
            <div className="col-md-12">
              <h4>
                <img
                  src={window.location.origin + "/images/Bag.png"}
                  className="row-img"
                  alt="BAGS"
                />{" "}
                BAGS
              </h4>
              <h5>Maintenance Guide</h5>
            </div>
          </div>
        </div>
        <div className="flex-row row">
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/M1.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Maximize Performance</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      To maximize performance & extend vacuum life, bags should
                      be checked and changed regularly.
                    </small>
                  </p>
                  <p className="flex-text">
                    <small className="text-muted">
                      STEP 1: Turn off and unplug cleaner before chnaging bag.
                      To locate and replace, refer to your owner's manual
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/M2.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Inspect Bag</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      STEP 2: Inspect bag to determine if it is full, if the
                      dirt reaches the full line or the bag feels firm to the
                      touch, if it's time to replace teh bag.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/M3.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Throw Away Bag</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      STEP 3: Carefully remove the bag from the machine and
                      throw it away.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/M4.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">
                    Replace Bag & Febreze&reg; Scent
                  </p>
                  <p className="flex-text">
                    <small className="text-muted">
                      STEP 4: Grab a new bag and insert it into the machine.
                      Refer to owner's manual for instalation instructions
                      specific to your machine.To release the Febreze&reg;
                      Scent. Open the wrapper on scent tag by puling along the
                      performance line.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="hr-style" />
        <div className="how-section1">
          <div className="row">
            <div className="col-md-12">
              <h4>
                <img
                  src={window.location.origin + "/images/Filters.png"}
                  alt="FILTERS"
                  className="row-img"
                />{" "}
                FILTERS
              </h4>
              <h5>Maintenance Guide</h5>
            </div>
          </div>
        </div>
        <div className="flex-row row">
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/M5.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Maximize Performance</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      To maximize performance & extend vacuum life, filters
                      should be cleaned after every use and replace every 3-6
                      months.
                    </small>
                  </p>
                  <p className="flex-text">
                    <small className="text-muted">
                      STEP 1: Turn off and unplug cleaner before chnaging
                      Filter. To locate and replace, refer to your owner's
                      manual
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/M6.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">
                    Remove Existing Filter & Inspect
                  </p>
                  <p className="flex-text">
                    <small className="text-muted">
                      STEP 2: Remove filter from vacuum. Inspect to determine if
                      it should be washed or replaced.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/M7.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Wash Filter</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      STEP 3: If washing, hand wash in warm water. Use mild
                      detergent, if desired. Allow filter to air dry completely
                      before placing back in machine.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="custom-column-contact">
              <div className="thumbnail">
                <div className="caption">
                  <img
                    className="img-fluid"
                    src={window.location.origin + "/images/M8.png"}
                    alt="Card cap"
                  />
                  <p className="lead font-weight-bold">Replace Filter</p>
                  <p className="flex-text">
                    <small className="text-muted">
                      STEP 4: If replacing, ensure all packaging is removed
                      prior to instalation. Refer to owner's manual for
                      instalation instruction specific to your machine.
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Help;
